import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { connect } from 'redaction'
import actions from 'redux/actions'
import { links, constants, array, getMergedProductAndVolume } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Modal from 'components/modal/Modal/Modal'
import { Grid, Cell } from 'components/_new/layout/grid'
import Button from 'components/buttons/Button/Button'
import { AddToQueueOrCartButton } from 'components/_new/buttons/addTo'
import CommonButton from 'components/buttons/CommonButton/CommonButton'

import messages from './messages'
import s from './MembershipInfoModal.scss'

import step1 from './images/step1.svg'
import step2 from './images/step2.svg'
import step3 from './images/step3.svg'


const steps = [
  step1,
  step2,
  step3,
]


class MembershipInfoModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  }

  static defaultProps = {
    name: constants.modals.MembershipInfo,
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const {
      name, data: { id, img, brand, activeVolume, metadata, snowplowMetadata },
      isSubscribed,
    } = this.props

    const addTo       = activeVolume ? (activeVolume.type === 'subscription' ? 'queue' : 'cart') : false
    const product     = { id, name, brand, img }
    const productInfo = getMergedProductAndVolume(product, activeVolume)
    const isAddToQueueButtonDisabled = activeVolume ? !activeVolume.inStock : true

    return (
      <Modal
        className={s.membershipInfoModal}
        name={name}
        onClose={this.close}
      >
        <Grid
          className={s.steps}
          columns={{
            mobile: 1,
            tabletPortrait: 1,
            tabletLandscape: 3,
            desktop: 3,
          }}
        >
          {
            array.range(1, 3).map((count, index) => {
              const title        = messages[`title${count}`]
              const description  = messages[`description${count}`]

              return (
                <Cell key={count} className={s.step} size={1}>
                  <div className={s.row}>
                    <div className={s.number}>{count}</div>
                    <FormattedHTMLMessage className={s.title} {...title} />
                  </div>
                  <FormattedHTMLMessage tag="div" className={s.description} {...description} />
                  <img className={s.image} src={steps[index]} alt="Scentbird membership" />
                </Cell>
              )
            })
          }
        </Grid>
        <div className={s.buttons}>
          {
            addTo ? (
              <AddToQueueOrCartButton
                className={s.button}
                disabled={isAddToQueueButtonDisabled}
                product={productInfo}
                title={isSubscribed ? null : messages.subscribeNow}
                onAfterAdd={this.close}
                addTo={addTo}
                metadata={metadata}
                snowplowMetadata={snowplowMetadata}
                brand
                xlg
                dataTestId={constants.testIds.payment.addProductButton}
              />
            ) : (
              <CommonButton
                className={s.button}
                to={links.register}
                onClick={this.close}
                subscribeNow
                brand
                xlg
                dataTestId={constants.testIds.payment.addProductButton}
              />
            )
          }
          <Button
            className={cx(s.button, s.backButton)}
            textButton
            title={messages.back}
            onClick={this.close}
          />
        </div>
      </Modal>
    )
  }
}


export default connect({
  isSubscribed: 'models.subscriptiption.isSubscribed',
})(MembershipInfoModal)
